// Header.js
import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <AppBar position="static" sx={{ marginBottom: 4 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Gestion web
        </Typography>

        <Button color="inherit" component={Link} to="/create">
          Crear Perfil web
        </Button>
        <Button color="inherit" component={Link} to="/list">
          Médicos
        </Button>
        {/* <Button color="inherit" component={Link} to="/services">
          Subir Servicio
        </Button> */}
        {/* <Button color="inherit" component={Link} to="/servicios">
          Subir JSON
        </Button> */}
        <Button color="inherit" component={Link} to="/crearblog">
          Crear Blog
        </Button>
        <Button color="inherit" component={Link} to="/oferta">
          Crear Oferta
        </Button>
        <Button color="inherit" component={Link} to="/postulaciones">
          Postulaciones
        </Button>
        <Button color="inherit" component={Link} to="/comentarios">
          Comentarios
        </Button>
      </Toolbar>
    </AppBar>
  );
}